// extracted by mini-css-extract-plugin
export default {"userRowContainer":"postPermissionOperations-module__userRowContainer--pqdjC","animatedBackground":"postPermissionOperations-module__animatedBackground--yXCIS"};